import { IAdsService } from "../../types/IAdsService";
import { IBid, IProvider } from "../provider";

declare global {
  interface Window {
    Pogo?: {
      getVideoTag: (params: any, cb: (videoUrl: string) => void) => void;
    }
  }
}

export class MashableAdsService implements IAdsService {
  constructor() {
    if (!window.Pogo && !document.querySelector('script[src*=""]')) {
      const script = document.createElement('script');
      script.src = 'https://acdn.adnxs.com/ast/ast.js';
      script.async = true;
      (document.head || document.body).appendChild(script);
    }
  }

  public request(duration = 30, isDev = false): Promise<IBid[]> {
    function pogoRequest(cb: (url: string) => void): any {
      if (!window.Pogo) return setTimeout(() => pogoRequest(cb), 200);
      window.Pogo.getVideoTag({ videoId: 'preroll', playerId: 'ark_pre-roll' }, cb);
    }
    return new Promise((resolve, reject) => {
      setTimeout(() => resolve([]), 5000);
      pogoRequest((adUrl) => resolve([{ bid: { cpm: 0 }, provider: this.createStubProvider(adUrl) }]));
    });
  }

  public retryRequest(): Promise<IBid[]> {
    return Promise.resolve([]);
  }

  public getBid(): Promise<{ cpm: number; bidder: string; url: string; }> {
    return Promise.reject();
  }

  public cleanBids(): void {

  }

  protected createStubProvider(url: string): IProvider {
    return {
      name: 'pogo',
      configure() { },
      requestBids: () => Promise.resolve([]),
      buildVideoUrl: () => Promise.resolve(url),
    };
  }
}
